import { GETINVOICEDETAILS_SUCCESS, GETINVOICEDETAILS_FAIL, INVOICE_CUSTOMERID, INVOICE_PROJECTID, INVOICE_STATUS, ROW_COUNT } from '../actionTypes';

const initialState = {
    user: [],
    invoiceSetCustId: {},
    invoiceSetProjId: {},
    invoiceSetStatus: {},
    rowCount:10,
};

const getInvoiceDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETINVOICEDETAILS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETINVOICEDETAILS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        case INVOICE_CUSTOMERID:
            return {
                ...state,
                invoiceSetCustId: action.payload
            }
        case INVOICE_PROJECTID:
            return {
                ...state,
                invoiceSetProjId: action.payload
            }
        case INVOICE_STATUS:
            return {
                ...state,
                invoiceSetStatus: action.payload
            }
            case ROW_COUNT:
            return {
                ...state,
                rowCount: action.payload
            }
        default:
            break;
    }

    return state;
};

export default getInvoiceDetailsReducer;
